import React from 'react'
import { useTranslation } from 'react-i18next'

import format from 'date-fns/fp/format'

import { Mode } from '../enums'

import cs from '../i18n/cs.json'
import en from '../i18n/en.json'

interface IProps {
  dateDisabled: boolean
  selectedDate: Date
  mode: Mode
  onChangeMode: (mode: Mode) => void
}

const DateHeader = (props: IProps) => {
  const { t, i18n } = useTranslation('DateHeader')

  i18n.addResourceBundle('cs', 'DateHeader', cs)
  i18n.addResourceBundle('en', 'DateHeader', en)

  const datePartClass = props.dateDisabled ? 'cs-rdatepicker__datepart error' : 'cs-rdatepicker__datepart'

  return (
    <div className='cs-rdatepicker__header'>
      <div className='cs-rdatepicker__dateparts'>
        <div className={datePartClass}>
          <button
            type='button'
            className={props.mode === Mode.Day ? 'active' : 'non-active'}
            onClick={() => props.onChangeMode(Mode.Day)}
          >
            {format('d')(props.selectedDate)}
            <span className='caret'></span>
          </button>
        </div>
        <div className='cs-rdatepicker__datepart'>
          <button
            type='button'
            className={props.mode === Mode.Month ? 'active' : 'non-active'}
            onClick={() => props.onChangeMode(Mode.Month)}
          >
            {t(format('MM')(props.selectedDate))}
            <span className='caret'></span>
          </button>
        </div>
        <div className='cs-rdatepicker__datepart'>
          <button
            type='button'
            className={props.mode === Mode.Year ? 'active' : 'non-active'}
            onClick={() => props.onChangeMode(Mode.Year)}
          >
            {format('yyyy')(props.selectedDate)}
            <span className='caret'></span>
          </button>
        </div>
      </div>
      {props.dateDisabled && <div className='cs-rdatepicker__error'>{t('ERROR_MSG')}</div>}
    </div>
  )
}

export default DateHeader
